import Vue from "vue";
import VueRouter from "vue-router";

import Root from "@/views/Root.vue";
import i18n from "@/i18n";
import Custom from "@/plugins/Custom";

Vue.use(VueRouter);

export default new VueRouter({
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: "/",
            beforeEnter: (to, from, next) => {
                const supportedLocales = ["de","en"];
                const browserLocale = (navigator.language || navigator.userLanguage).split('-')[0];
                if(supportedLocales.indexOf(browserLocale) !== -1) {
                    return next('/' + browserLocale)
                }
                
                return next('/' + process.env.VUE_APP_I18N_FALLBACK_LOCALE)
            }
        },
        {
            path: '/:locale(de|en)?',
            name: 'main',
            component: Root,
            beforeEnter: (to, from, next) => {
                i18n.locale = to.params.locale;
                const targetRouteConfig = Vue.getRouteConfig(to.name);
                const targetRoute = '/' + to.params.locale + '/' + targetRouteConfig.paths[to.params.locale];
                if(targetRoute !== to.path) {
                    return next(targetRoute)
                }
                return next();
            },
            children: Custom.getRouteConfigs()
        },
        {
            path: '*',
            redirect: '/'
        }
    ],
    socials: [
        {
            path: "https://www.facebook.com/wiebke.winzer",
            component: null,
            name: '...',
            icon: 'mdi-facebook',
        },
        {
            path: "https://www.instagram.com/breathe2bliss/",
            component: null,
            name: '...',
            icon: 'mdi-instagram',
        },
        {
            path: "mailto:info@wiebkewinzer.de",
            component: null,
            name: '...',
            icon: 'mdi-email',
        },  
    ],
    mode: "history"
});